import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#0064FF",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M13.61 3.724c.52.52.52 1.365 0 1.885l-7.477 7.477-3.742-3.743a1.333 1.333 0 0 1 1.885-1.886l1.857 1.857 5.59-5.59c.522-.52 1.366-.52 1.886 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }